import { Colors } from '../../consts/Colors';

export default class Zone3 extends Phaser.GameObjects.Container {
    constructor(scene, zoneData) {
        super(scene, zoneData.zoneX, zoneData.zoneY, []);

        scene.add.existing(this);
        this.scene = scene;
        this.zoneData = zoneData;
        this.zoneId = zoneData.zoneId;

        this.cardDropped = undefined;
        this.isDone = false;

        this.dropZone = this.scene.add.image(0, 0, zoneData.image).setOrigin(0.5);
        this.add(this.dropZone);
        this.setActive()
        // this.annimation()

    }
    setActive() {
        this.setSize(this.dropZone.width, this.dropZone.height);
        this.setInteractive({ dropZone: true });
    }

    onPointerOver() {
        this.dropZone.setTint(Colors.Elmt.DarkGrey);
    }
    onPointerOut() {
        this.dropZone.setTint(0xFFFFFF);

    }
    dragOnPointerOver() {
        this.dropZone.setTint(Colors.Elmt.DarkGrey);
    }
    dragOnPointerOut() {
        this.dropZone.setTint(0xFFFFFF);

    }
    onDrop(cardDropped) {
        let previousCard = undefined
        if (this.cardDropped !== undefined) {
            this.cardDropped.reset()
            previousCard = this.cardDropped
        }

        this.cardDropped = cardDropped
        cardDropped.x = this.x - cardDropped.parentContainer.x
        cardDropped.y = this.y - cardDropped.parentContainer.y

        this.dropZone.setTint(0xFFFFFF);
        this.isDone = true;

        return previousCard
    }

    reset() {
        this.setActive()
        this.isDone = false;
        this.cardDropped = undefined
    }

    bounceAnimation(delay){
        this.scene.tweens.add({
            targets: this.dropZone,
            scale: 1.2,
            duration: 200,
            delay: delay,
            yoyo: true,
        });
    }

}